import React from 'react'
import { Box } from '../layout'
import { Icon } from './'
import './Dialog.css'

export const Dialog = ({ open, onClose, closeColor, children }) => (
  <Box
    className="dialog-container"
    onClick={onClose}
    zIndex={open ? 10 : -10}
  >
    <Box className="dialog-overlay" opacity={open ? 1 : 0} />
    <Box
      className={`dialog ${open ? ' slide-in' : ' slide-out'}`}
      opacity={open ? 1 : 0}
      column
      onClick={(event) => event.stopPropagation()}
    >
      <Box
        className="close-button"
        position="absolute"
        top={0}
        right={0}
        p={16}
        cursor="pointer"
        onClick={onClose}
      >
        <Icon icon="Close" size={24} fill={closeColor} />
      </Box>
      {children}
    </Box>
  </Box>
)